import { roundTo } from './data-manipulation/valueFormatter'
import { ROUNDING_PRECISIONS, FEE_OR_PROMOTION_TYPE } from './constants'

/**
 * Calculates fee or promotion value using the same logic as backend FeeOrPromotionService.getFP
 */
export const calculateFeePromotionValue = (feeOrPromotion, ibtNetCost, forceRecalculate = false) => {
  // If there's already a calculated value from the backend, use it (unless forcing recalculation)
  if (!forceRecalculate && feeOrPromotion.calculatedValue !== undefined && feeOrPromotion.calculatedValue !== null) {
    return feeOrPromotion.calculatedValue
  }

  if (feeOrPromotion.amountType === 'FLAT') {
    // For flat amounts, apply the sign based on fee/promotion type
    const absoluteValue = Math.abs(feeOrPromotion.amount)
    return feeOrPromotion.type === FEE_OR_PROMOTION_TYPE.FEE ? -absoluteValue : absoluteValue
  }

  if (feeOrPromotion.amountType === 'PERCENT') {
    // Calculate percentage on materials net cost only (before freight chargeback)
    const percentageValue = roundTo((Math.abs(ibtNetCost) * feeOrPromotion.amount) / 100, ROUNDING_PRECISIONS.COST)

    // Apply the correct sign based on fee/promotion type
    const result = feeOrPromotion.type === FEE_OR_PROMOTION_TYPE.FEE ? -percentageValue : percentageValue
    return result
  }

  console.warn('Unknown fee/promotion amount type:', feeOrPromotion.amountType)
  return 0
}

/**
 * Calculates total fees and promotions including freight chargeback (same logic as utils function)
 */
export const calculateFeesAndPromotionsTotal = (feesAndPromotions, ibtNetCost, freightChargeback = 0) => {
  // Start with freight chargeback as negative (same as utils function)
  let total = -freightChargeback

  feesAndPromotions.forEach(feeOrPromotion => {
    const value = calculateFeePromotionValue(feeOrPromotion, ibtNetCost)
    total = roundTo(total + value, ROUNDING_PRECISIONS.COST)
  })

  return total
}

/**
 * Creates fee/promotion grid row objects for display
 */
export const createFeePromotionGridRows = (feesAndPromotions, ibtNetCost, freightChargeback = 0, options = {}) => {
  return feesAndPromotions
    .map(feeOrPromotion => {
      // Skip if paid ticket and not applied
      if (options.isPaidTicket && !feeOrPromotion.applied) {
        return null
      }

      const calculatedValue = calculateFeePromotionValue(feeOrPromotion, ibtNetCost)

      return {
        id: feeOrPromotion.settingId,
        rowType: feeOrPromotion.type?.toLowerCase(),
        code: feeOrPromotion.name,
        gross: null,
        tare: null,
        um: null,
        netWeight: null,
        price: feeOrPromotion.amount,
        netValue: calculatedValue,
        amountType: feeOrPromotion.amountType,
        eligiblePaymentTypes: feeOrPromotion.eligiblePaymentTypes,
        showPaymentMethodSpecificIcon: options.showPaymentMethodSpecificIcon || false,
      }
    })
    .filter(Boolean) // Remove null entries
}
